import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import { initI18n } from './i18n'

initI18n()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(<App />)
